
import { Component, Vue, Prop } from "vue-property-decorator";
import { Quests } from "@/models/MapPois/Quest/Quests";
import {
  Q_QUEST_STATUS,
  Q_QUEST_TYPE,
} from "@/models/MapPois/Quest/QuestsEnum";

@Component
class ComposeQuestTable extends Vue {
  @Prop({ default: false }) readonly isEditingLocked!: boolean;
  searchFilter = "";
  busy = false;
  currentPage = 1;
  perPage = 5;
  fields = [
    {
      key: "title",
      label: "Title",
      sortable: true,
    },
    {
      key: "type",
      label: "Type",
      sortable: true,
    },
    {
      key: "unlocked",
      label: "Starts @none",
      sortable: true,
    },
    {
      key: "affectsGame",
      label: "Game Actions?",
      sortable: true,
    },
    {
      key: "goals",
      label: "Goals",
      sortable: true,
    },
    {
      key: "action",
      label: "#Actions",
      sortable: true,
    },
    {
      key: "valid",
      label: "Valid",
      sortable: true,
    },
  ];
  get getQuestData(): Quests[] {
    return this.$store.state.questStore.quest;
  }

  getRowCssClass(item: any): string {
    if (item.issues !== undefined && item.issues.err !== undefined) {
      return "highlight-row";
    } else {
      return "";
    }
  }

  getTypeName(value: number): string {
    if (value === Q_QUEST_TYPE.MAIN) {
      return "Main (DEFAULT)";
    }
    if (value === Q_QUEST_TYPE.PRIMARY) {
      return "Primary";
    }
    if (value === Q_QUEST_TYPE.SECONDARY) {
      return "Secondary";
    }
    if (value === Q_QUEST_TYPE.MISC) {
      return "Misc";
    }
    return value.toString();
  }

  getIsValid(): boolean {
    return true;
  }

  getUnlocked(item: Quests): boolean {
    if (item.statusGoals[Q_QUEST_STATUS.NONE].exitGoals === undefined) {
      return true;
    } else {
      return false;
    }
  }

  getAffectGame(item: Quests): boolean {
    if (
      item.statusGoals[Q_QUEST_STATUS.FINAL].actions?.gameStatusAction ===
      undefined
    ) {
      return false;
    } else {
      return true;
    }
  }

  getGoalsCount(item: Quests): number {
    var goalCount = 0;
    var statusGoal = Object.values(item.statusGoals);
    statusGoal.forEach((x: any) => {
      if (x.exitGoals !== undefined) {
        goalCount += Object.keys(x.exitGoals).length;
      }
    });
    return goalCount;
  }

  getActionCount(item: Quests): number {
    var actionCount = 0;
    var statusGoal = Object.values(item.statusGoals);
    statusGoal.forEach((x: any) => {
      if (x.actions !== undefined) {
        actionCount += Object.keys(x.actions).length;
      }
    });
    return actionCount;
  }
  filterByTitleName(row: any) {
    if (row.title.en.toLowerCase().includes(this.searchFilter.toLowerCase())) {
      return true;
    }
    return false;
  }

  onRowSelected(rows: any): void {
    //I'm not sure what type this should be. I have called any for the time being
    let myTable = this.$refs.composeTable as any;
    myTable.clearSelected();
    this.$emit("handleTableSelection", rows[0]);
  }
}

export default ComposeQuestTable;
